/* import __COLOCATED_TEMPLATE__ from './infinite-scroll-selection-modal.hbs.js'; */
var _class, _descriptor, _descriptor2, _descriptor3;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import { action } from '@ember/object';
import { inject as service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import * as Sentry from '@sentry/browser';
let InfiniteScrollSelectionModal = (_class = class InfiniteScrollSelectionModal extends Component {
  constructor(owner, args) {
    super(owner, args);
    _initializerDefineProperty(this, "isLoadingMoreOptions", _descriptor, this);
    _initializerDefineProperty(this, "intl", _descriptor2, this);
    _initializerDefineProperty(this, "currentSelectionState", _descriptor3, this);
    this.currentSelectionState = {
      ...this.args.selectionState,
      selectedOptionIds: new Set(this.args.selectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.args.selectionState.deselectedOptionIds)
    };
  }
  get modalOptions() {
    return {
      enableSearch: true,
      enableSelectAll: true,
      title: this.intl.t('sharedUi.infiniteScrollSelectionModal.title'),
      primaryButtonLabel: this.intl.t('sharedUi.common.done'),
      selectAllLabel: this.intl.t('sharedUi.infiniteScrollSelectionModal.selectAllLabel'),
      searchPlaceholder: this.intl.t('sharedUi.infiniteScrollSelectionModal.searchPlaceholder'),
      ...this.args.modalOptions
    };
  }
  get optionsValue() {
    return this.options.filter(option => option.checked).map(option => option.id);
  }
  get options() {
    return this.args.options.map(option => {
      if (option.disabled) {
        return option;
      }
      let checked;
      if (this.currentSelectionState.selectedAllOptions) {
        checked = !this.currentSelectionState.deselectedOptionIds.has(option.id);
      } else if (this.currentSelectionState.deselectedAllOptions) {
        checked = this.currentSelectionState.selectedOptionIds.has(option.id);
      } else {
        checked = this.currentSelectionState.selectedOptionIds.has(option.id);
      }
      return {
        ...option,
        checked
      };
    });
  }
  get hasIndividuallySelectedAllOptions() {
    const {
      selectedOptionIds
    } = this.currentSelectionState;
    return selectedOptionIds.size === this.args.options.length && !this.args.hasMoreOptions;
  }
  get isSelectAllCheckboxChecked() {
    const {
      selectedAllOptions,
      deselectedOptionIds
    } = this.currentSelectionState;
    const allSelected = selectedAllOptions && deselectedOptionIds.size === 0;
    return allSelected || this.hasIndividuallySelectedAllOptions;
  }
  selectAllClicked() {
    // Check if currently not all options are selected
    if (!this.isSelectAllCheckboxChecked || this.currentSelectionState.deselectedOptionIds.size > 0) {
      // Select all options
      this.currentSelectionState.selectedAllOptions = true;
      this.currentSelectionState.deselectedAllOptions = false;
      this.currentSelectionState.selectedOptionIds.clear();
      this.currentSelectionState.deselectedOptionIds.clear();
    } else {
      // Deselect all options
      this.currentSelectionState.selectedAllOptions = false;
      this.currentSelectionState.deselectedAllOptions = true;
      this.currentSelectionState.selectedOptionIds.clear();
      this.currentSelectionState.deselectedOptionIds.clear();
    }
    this.refreshCurrentSelectionState();
  }
  optionClicked(optionId) {
    const {
      selectedOptionIds,
      deselectedOptionIds,
      selectedAllOptions,
      deselectedAllOptions
    } = this.currentSelectionState;
    if (selectedAllOptions) {
      if (deselectedOptionIds.has(optionId)) {
        deselectedOptionIds.delete(optionId);
      } else {
        deselectedOptionIds.add(optionId);
      }
    } else if (deselectedAllOptions) {
      if (selectedOptionIds.has(optionId)) {
        selectedOptionIds.delete(optionId);
      } else {
        selectedOptionIds.add(optionId);
      }
    } else {
      if (selectedOptionIds.has(optionId)) {
        selectedOptionIds.delete(optionId);
        deselectedOptionIds.add(optionId);
      } else if (deselectedOptionIds.has(optionId)) {
        deselectedOptionIds.delete(optionId);
        selectedOptionIds.add(optionId);
      } else {
        selectedOptionIds.add(optionId);
      }
    }
    this.refreshCurrentSelectionState();
  }
  refreshCurrentSelectionState() {
    this.currentSelectionState = {
      selectedOptionIds: new Set(this.currentSelectionState.selectedOptionIds),
      deselectedOptionIds: new Set(this.currentSelectionState.deselectedOptionIds),
      selectedAllOptions: this.currentSelectionState.selectedAllOptions,
      deselectedAllOptions: this.currentSelectionState.deselectedAllOptions
    };
  }
  async handleScroll() {
    if (this.isLoadingMoreOptions || !this.args.hasMoreOptions) {
      return;
    }
    try {
      this.isLoadingMoreOptions = true;
      await this.args.loadMoreOptions();
    } catch (err) {
      Sentry.captureException(err);
    } finally {
      this.isLoadingMoreOptions = false;
    }
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isLoadingMoreOptions", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "currentSelectionState", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _applyDecoratedDescriptor(_class.prototype, "selectAllClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "selectAllClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "optionClicked", [action], Object.getOwnPropertyDescriptor(_class.prototype, "optionClicked"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "handleScroll", [action], Object.getOwnPropertyDescriptor(_class.prototype, "handleScroll"), _class.prototype)), _class);
export { InfiniteScrollSelectionModal as default };